'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useCallback, useEffect, useState } from 'react';
import { closeResponsiveDialogWithoutHistory, requestCloseResponsiveDialog, RESPONSIVE_DIALOG_HISTORY_KEY, useResponsiveDialogStore } from '@/stores/DrawerStore';
const ResponsiveDialog = dynamic(() => import('../../organism/ResponsiveDialog').then(mod => ({
  default: mod.ResponsiveDialog
})), {
  ssr: false
});

/**
 * 데스크톱에서는 모달, 모바일에서는 드로워로 표시\
 * openResponsiveDialog를 이용해서 간결하게 사용 가능
 *
 * @example
 *
 * ```tsx
 * import { openResponsiveDialog } from '@/stores/DrawerStore';
 *
 * openResponsiveDialog({
 *   component: HouseholdConsent,
 * });
 * ```
 */
export const ResponsiveDialogContainer = () => {
  const $ = _c(22);
  const {
    currentDialog,
    isOpen
  } = useResponsiveDialogStore();
  const [isMounted, setIsMounted] = useState(false);
  const shouldUseHistory = isOpen && !!currentDialog;
  const handleCloseWithoutHistory = _temp;
  const requestClose = _temp2;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== isOpen) {
    t2 = () => {
      const handleKeyDown = event => {
        if (event.key === "Escape" && isOpen) {
          requestClose();
        }
      };
      if (isOpen) {
        document.addEventListener("keydown", handleKeyDown);
      }
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t3 = [isOpen, requestClose];
    $[2] = isOpen;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== shouldUseHistory) {
    t4 = () => {
      if (!shouldUseHistory) {
        return;
      }
      const state = {
        ...window.history.state,
        [RESPONSIVE_DIALOG_HISTORY_KEY]: true
      };
      window.history.pushState(state, "");
      const handlePopState = event_0 => {
        if (useResponsiveDialogStore.getState().isOpen) {
          event_0.preventDefault();
          handleCloseWithoutHistory();
        }
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    };
    t5 = [shouldUseHistory, handleCloseWithoutHistory];
    $[5] = shouldUseHistory;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  if (!isMounted || !currentDialog) {
    return null;
  }
  const Component = currentDialog.component;
  let t6;
  if ($[8] !== Component || $[9] !== currentDialog.props) {
    t6 = <Component {...currentDialog.props} onClose={requestClose} />;
    $[8] = Component;
    $[9] = currentDialog.props;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== currentDialog.className || $[12] !== currentDialog.drawerNoPadding || $[13] !== currentDialog.drawerType || $[14] !== currentDialog.duration || $[15] !== currentDialog.forceModal || $[16] !== currentDialog.hideDrawerHeader || $[17] !== currentDialog.modalHeader || $[18] !== currentDialog.title || $[19] !== isOpen || $[20] !== t6) {
    t7 = <ResponsiveDialog opened={isOpen} onClose={requestClose} title={currentDialog.title} duration={currentDialog.duration} className={currentDialog.className} modalHeader={currentDialog.modalHeader} drawerNoPadding={currentDialog.drawerNoPadding} hideDrawerHeader={currentDialog.hideDrawerHeader} drawerType={currentDialog.drawerType} forceModal={currentDialog.forceModal}>{t6}</ResponsiveDialog>;
    $[11] = currentDialog.className;
    $[12] = currentDialog.drawerNoPadding;
    $[13] = currentDialog.drawerType;
    $[14] = currentDialog.duration;
    $[15] = currentDialog.forceModal;
    $[16] = currentDialog.hideDrawerHeader;
    $[17] = currentDialog.modalHeader;
    $[18] = currentDialog.title;
    $[19] = isOpen;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
function _temp() {
  closeResponsiveDialogWithoutHistory();
}
function _temp2() {
  requestCloseResponsiveDialog();
}